/**
 * SubtaskProgress — "Subtasks N/M" label + thin progress bar.
 *
 * Mockup pattern from Board.html:
 *   <div class="progress-lab"><span>Subtasks</span><span>{done}/{total}</span></div>
 *   <div class="progress"><i style="width:{pct}%"/></div>
 */

interface SubtaskProgressProps {
  done: number;
  total: number;
  label?: string;
}

export function SubtaskProgress({
  done,
  total,
  label = "Subtasks",
}: SubtaskProgressProps) {
  if (total === 0) return null;
  const pct = Math.round((done / total) * 100);
  return (
    <>
      <div className="progress-lab">
        <span>{label}</span>
        <span>
          {done}/{total}
        </span>
      </div>
      <div className="progress">
        <i style={{ width: `${pct}%` }} />
      </div>
    </>
  );
}
